export default __webpack_public_path__ + "static/media/noty.9287f5ce.mp3";